// extracted by mini-css-extract-plugin
export default {"item":"BreadcrumbItem_item__qvl4v","active":"BreadcrumbItem_active__GWdo0"};